export default __webpack_public_path__ + "static/media/NIAS0360.34I-32925_-17935_0.073d7a29.jpg";